import { navigate as reachNavigate } from "@reach/router";

export const absolute = (url) => url;

export const navigate = (url) => reachNavigate(absolute(url));

export const get_intellifox_url = () => {
  return window.document.location.origin;
};
